import { Directive } from '@angular/core';

@Directive({
  selector: '[appScroll]'
})
export class ScrollDirective {

  constructor() { }
  ngOnInit() {
      window.addEventListener('scroll', this.scroll, true); //third parameter
  }

  ngOnDestroy() {
      window.removeEventListener('scroll', this.scroll, true);
  }

  scroll = (): void => {
    console.log('hola scroll');
  };

}



// WEBPACK FOOTER //
// /Users/administrador/Trabajos/pascal3/src/app/scroll.directive.ts